export default function onlinePlugin(store) {
  window.addEventListener('online', () => {
    store.commit('browser/SET_ONLINE');
  });

  window.addEventListener('offline', () => {
    store.commit('browser/SET_OFFLINE');
  });
}
